import { STEPS, stepIndex } from "@/lib/shipments";

// Barra de etapas: concluídas, atual (destacada) e próximas.
export const TrackSteps = ({ status }) => {
  const cur = stepIndex(status);
  return (
    <ol data-testid="track-steps" className="grid gap-2 sm:grid-cols-6 sm:gap-3">
      {STEPS.map((s, i) => {
        const Icon = s.icon;
        const done = i <= cur;
        const now = i === cur;
        return (
          <li key={s.id} data-testid={`track-step-${s.id}`} data-state={now ? "current" : done ? "done" : "todo"}
            className={`flex items-center gap-3 rounded-2xl border px-4 py-3 transition-colors sm:flex-col sm:items-start sm:gap-2 ${now ? "border-white bg-white text-black" : done ? "border-white/20 bg-white/[0.06] text-white" : "border-white/10 text-zinc-400"}`}>
            <Icon className="h-5 w-5 shrink-0" />
            <span className="text-sm font-semibold leading-tight">{s.label}</span>
          </li>
        );
      })}
    </ol>
  );
};
